<template  lang="pug">
  v-layout.box-title-monto-formatter(style="height: 48px;width:15em" column align-center)
    v-flex(style="display: flex;align-items: center;")
      v-layout(column align-center)
        v-flex.box-title
          span {{title}}
        v-flex.box-monto
          span {{mensaje}}
      
    
</template>

<script>
export default {
  props: [
    "title",
    "mensaje",
  ]

}
</script>

<style scoped>
@media (min-width: 360px) {

  .box-title-monto-formatter {
    border: 1px solid #919191;
    border-radius: 3px;
    background: #F3F3F3;
    padding: 0.2em;
  }

  .box-title-monto-formatter .box-title {
    line-height: initial;
  }

  .box-title-monto-formatter .box-title span {
    color: var(--text-color);
    font-size: 13px;
  }

  .box-title-monto-formatter .box-monto {
    line-height: initial
  }

  .box-title-monto-formatter .box-monto span {
    color: #1F1F1F;
    font-size: 17px;
  }

}

@media (min-width: 1200px) {
  .box-title-monto-formatter .box-title span {
    color: var(--text-color);
    font-size: 11px;
  }

  .box-title-monto-formatter .box-monto span {
    color: #1F1F1F;
    font-size: 15px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/generic/BoxTitleMonto.vue